import { render, staticRenderFns } from "./CorrectionSystemNew.vue?vue&type=template&id=b653cf3e"
import script from "./CorrectionSystemNew.vue?vue&type=script&lang=js"
export * from "./CorrectionSystemNew.vue?vue&type=script&lang=js"
import style0 from "./CorrectionSystemNew.vue?vue&type=style&index=0&id=b653cf3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports